export default __webpack_public_path__ + "static/media/minio.0ed0e5e1.jpg";